import { render, staticRenderFns } from "./goods-category-dialog.vue?vue&type=template&id=1c232c24&scoped=true"
import script from "./goods-category-dialog.vue?vue&type=script&lang=js"
export * from "./goods-category-dialog.vue?vue&type=script&lang=js"
import style0 from "./goods-category-dialog.vue?vue&type=style&index=0&id=1c232c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c232c24",
  null
  
)

export default component.exports